import Header from "../components/Header";

import UpdateForm from './components/UpdateForm'

function UpdateOffer() {
    let pagesLinks = [

        {
            name: "تعديل العرض",
            link: `/admin/offers`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        { name: "العروض", link: `/admin/offers` },
    ];

    return (
        <div>
            <Header pageName="تعديل العرض" pages={pagesLinks} className="text-2xl" />

            <UpdateForm />
        </div>
    )
}

export default UpdateOffer